import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CampoAdicionalService } from '../../campo-adicional.service';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { CampoAdicionalListComponent } from '../campo-adicional-list/campo-adicional-list.component';
import { DocumentoService } from '../../../documento/documento.service';

@Component({
  selector: 'app-associate-questions',
  templateUrl: './associate-questions.component.html',
  styleUrls: ['./associate-questions.component.scss']
})
export class AssociateQuestionsComponent implements OnInit {
  associateQuestionForm: FormGroup;
  viewOptionSelected : any;
  //MainQuestion
  mainQuestionTitle : string;
  //

  //iterables
  optionCount : number = 1;
  questionCount : number = 1;
  //iterables

  //model jsons
  optionYesJson : Object = {
    id : Number(`${this.questionCount}${this.optionCount++}`),
    descripcion : 'Si',
    preguntas_hijas : []
  };

  optionNoJson : Object = {
    id : Number(`${this.questionCount}${this.optionCount++}`),
    descripcion : 'No',
    preguntas_hijas : []
  };

  questionJson : any = {
    id : this.questionCount++,
    fatherQuestion : '',
    options : []
  };

  optionJson : Object;
  //model jsons

  constructor(
    private formBuilder: FormBuilder,
    private campoAdicionalService: CampoAdicionalService,
    private documentoService: DocumentoService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data
    ) { }

  ngOnInit() {
    this.createForm();
    this.getMainQuestionBranch();
    this.fillMainQuestion();
  }

  createForm() {
    const { isDocument } = this.data;
    this.associateQuestionForm = this.formBuilder.group(
      (isDocument)
      ? { documento_id : [null], descripcion_tipo_dato : [null],
        tipo_dato_id : [null], opciones : [[]] }
      : { campo_adicional_id : [null], descripcion_tipo_dato : [null],
        tipo_dato_id : [null], opciones : [[]] });
	}

  fillMainQuestion() {
    const { isDocument } = this.data;
    (isDocument) ? this.documentQuestion() : this.CampoAdicionalQuestion();
  }

  documentQuestion() {
    const { descripcion } = this.data.entry;
    this.questionJson.fatherQuestion = descripcion;
    this.questionJson.options = [this.optionYesJson, this.optionNoJson]
  }

  CampoAdicionalQuestion() {
    const { titulo } = this.data.entry;
    this.questionJson.fatherQuestion = titulo;
    this.questionJson.options = [this.optionYesJson, this.optionNoJson]
  }

  getMainQuestionBranch() {
    const { isDocument } = this.data;
    (isDocument) ? this.documentGetMainQuestionBranch() : this.CampoAdicionalgetMainQuestionBranch(); 
  }

  documentGetMainQuestionBranch() {
    const { documento_id } = this.data.entry;
    this.documentoService.getDataTypeBranchDetail( documento_id ).subscribe((res) => {
			if (res.result) {        
        const { documento_id, descripcion_tipo_dato, tipo_dato_id, opciones, descripcion } = res.data;

        this.mainQuestionTitle = descripcion;
        this.associateQuestionForm.setValue({
          documento_id, descripcion_tipo_dato, tipo_dato_id, opciones
        });

        if (this.associateQuestionForm.controls.opciones.value.length === 0) {
          this.fillMainQuestionOptions();
        }
			}
		})
  }

  CampoAdicionalgetMainQuestionBranch() {
    const { campo_adicional_id } = this.data.entry;
    this.campoAdicionalService.getDataTypeBranchDetail( campo_adicional_id ).subscribe((res) => {
			if (res.result) {
        const { campo_adicional_id, descripcion_tipo_dato, tipo_dato_id, opciones, titulo } = res.data;

        this.mainQuestionTitle = titulo;
        this.associateQuestionForm.setValue({
          campo_adicional_id, descripcion_tipo_dato, tipo_dato_id, opciones
        });

        if (this.associateQuestionForm.controls.opciones.value.length === 0) {
          this.fillMainQuestionOptions();
        }
			}
		})
  }



  fillMainQuestionOptions() {
    this.associateQuestionForm.controls.opciones.setValue([
      ...this.associateQuestionForm.controls.opciones.value, this.optionYesJson, this.optionNoJson
    ]);
  }

  createAssociateQuestions() {
    const { isDocument } = this.data;
    (isDocument) ? this.documentAssociateQuestions() : this.campoAdicionalAssociateQuestions();
  }

  documentAssociateQuestions() {
    this.documentoService.createQuestionBranch({...this.associateQuestionForm.value}).subscribe(
      (res) => {}
    )
  }

  campoAdicionalAssociateQuestions() {
    this.campoAdicionalService.createQuestionBranch({...this.associateQuestionForm.value}).subscribe(
      (res) => {}
    )
  }

  optionChange( e : any, index : number ) {
		const { name, value } = e.target;

    if (name) {
      this.associateQuestionForm.controls.opciones.value[index][name] = value;
    } else {
      if (Number(value) === 1) {
        const dialogRef = this.dialog.open(CampoAdicionalListComponent, { data: this.data.list });
      
        dialogRef.afterClosed().subscribe((result) => {
          this.associateQuestionForm.controls.opciones.value[index].preguntas_hijas = [
            ...this.associateQuestionForm.controls.opciones.value[index].preguntas_hijas,
            { ...result }
          ];
        });
      } else if (Number(value) === 0) {
        if (this.associateQuestionForm.controls.opciones.value[index].preguntas_hijas.length > 0) {
          this.associateQuestionForm.controls.opciones.value[index].preguntas_hijas.splice(0, 1);
        }
      }
    }
	}

  documentOptionChange( name : string, value : any, index : number ) {

  }

  campoAdicionalOptionChange( name : string, value : any, index : number ) {
    if (name) {
      this.associateQuestionForm.controls.opciones.value[index][name] = value;
    } else {
      if (Number(value) === 1) {
        const dialogRef = this.dialog.open(CampoAdicionalListComponent, { data: this.data.list });
      
        dialogRef.afterClosed().subscribe((result) => {
          this.associateQuestionForm.controls.opciones.value[index].preguntas_hijas = [
            ...this.associateQuestionForm.controls.opciones.value[index].preguntas_hijas,
            { ...result }
          ];
        });
      } else if (Number(value) === 0) {
        if (this.associateQuestionForm.controls.opciones.value[index].preguntas_hijas.length > 0) {
          this.associateQuestionForm.controls.opciones.value[index].preguntas_hijas.splice(0, 1);
        }
      }
    }
  }

  newOptionInput() {
    const { isDocument } = this.data;
    (isDocument) ? this.documentNewOptionInput() : this.campoAdicionalNewOptionInput();
	}

  documentNewOptionInput() {
    this.optionJson = {
      id : Number(`${this.questionCount}${this.optionCount++}`),
      descripcion : '',
      preguntas_hijas : []
    };

    this.associateQuestionForm.controls.opciones.setValue([
      ...this.associateQuestionForm.controls.opciones.value, this.optionJson
    ]);
  }

  campoAdicionalNewOptionInput() {
    this.optionJson = {
      id : Number(`${this.questionCount}${this.optionCount++}`),
      descripcion : '',
      preguntas_hijas : []
    };

    this.associateQuestionForm.controls.opciones.setValue([
      ...this.associateQuestionForm.controls.opciones.value, this.optionJson
    ]);
  }

  validationFormOptions() {
    let empty = null;
    let result = null;
    if (this.associateQuestionForm.controls.opciones?.value.length < 2) {
      result = true;
    } else {
      empty = this.associateQuestionForm.controls.opciones?.value.find((option : any) => option.descripcion == '');
      (!empty) ? result = false : result = true;
    }

    return result;
  }
}
